import { CONTENT_TAG_CATEGORIES_MAP } from '../../utils/constants';
import { head } from 'lodash';

export const getContentTagsByCategory = (contentTagIds, category, allTags) => {
  if (!allTags || !contentTagIds) return null;
  // Special case for CONTENT_TAG_CATEGORIES_MAP.topic
  const allSubthemes = allTags.filter(
    (tag) =>
      !(category === CONTENT_TAG_CATEGORIES_MAP.topic && !tag.parentId) && tag.category === category
  );

  const subthemes = allSubthemes.filter((theme) => contentTagIds.includes(theme._id));

  const subthemeTitles = subthemes.map((theme) => theme.title);
  return subthemeTitles;
};

export const getContentTagByCategory = (contentTagIds, category, allTags) => {
  const subthemes = getContentTagsByCategory(contentTagIds, category, allTags);
  return head(subthemes);
};
